import { render, staticRenderFns } from "./PintuanList.vue?vue&type=template&id=236d0787&scoped=true"
import script from "./PintuanList.vue?vue&type=script&lang=js"
export * from "./PintuanList.vue?vue&type=script&lang=js"
import style0 from "./PintuanList.vue?vue&type=style&index=0&id=236d0787&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236d0787",
  null
  
)

export default component.exports